import {
  getApplicantDocumentVerdictState,
  getIsApplicantChecklistRowBusy,
} from '../ApplicantDocumentChecklist.utils'
import { ApplicantDocumentChecklistHead } from '../ApplicantDocumentChecklistHead'
import { ApplicantDocumentChecklistRow } from '../ApplicantDocumentChecklistRow'

import * as styles from './ApplicantDocumentChecklistTable.module.css'

function ApplicantDocumentChecklistTable({
  applicantData,
  attachingKey,
  isPreview,
  rows,
  submittingKey,
  submittingStatus,
  onAttach,
  onClickFile,
  onReject,
  onVerify,
}) {
  const isChecklistBusy = Boolean(attachingKey || submittingKey)

  return (
    <div className={styles.ApplicantDocumentChecklistTable}>
      <div className={styles.rows}>
        <ApplicantDocumentChecklistHead />
        {rows.map(row => (
          <ApplicantDocumentChecklistRow
            isAttaching={getIsApplicantChecklistRowBusy({
              busyKey: attachingKey,
              row,
            })}
            isLocked={isChecklistBusy}
            isSubmitting={getIsApplicantChecklistRowBusy({
              busyKey: submittingKey,
              row,
            })}
            key={row.key}
            row={row}
            submittingStatus={submittingStatus}
            verdictState={getApplicantDocumentVerdictState({
              applicantData,
              isPreview,
              row,
            })}
            onAttach={onAttach}
            onClickFile={onClickFile}
            onReject={onReject}
            onVerify={onVerify}
          />
        ))}
      </div>
    </div>
  )
}

export default ApplicantDocumentChecklistTable
